// extracted by mini-css-extract-plugin
module.exports = {"tab":"Tab_tab__2467W","activebutton":"Tab_activebutton__3HFJm","normalbutton":"Tab_normalbutton__2-YZY"};